/* eslint-disable no-restricted-globals */
import { IS_SERVER } from "@/constants";
import { useEffect, useRef, useState, useCallback } from "react";
export function useScrollEffect(ad1Ref, ad2Ref, containerRef, options = {}) {
    const { offset = 500, stickyTop = 150 } = options;
    const [pinnedAd1, setpinnedAd1] = useState(false);
    const [ad1Top, setAd1Top] = useState(0);
    const lastScrollY = useRef(IS_SERVER ? 0 : window.scrollY);
    const scrollDir = useRef("down");
    const pinnedAd1Ref = useRef(pinnedAd1);
    const handleScroll = useCallback(() => {
        var _a, _b, _c;
        const currentScroll = window.scrollY;
        scrollDir.current = currentScroll > lastScrollY.current ? "down" : "up";
        lastScrollY.current = currentScroll;
        const ad1Rect = (_a = ad1Ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        const ad2Rect = (_b = ad2Ref.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        const containerRect = (_c = containerRef.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect();
        if (!ad1Rect || !ad2Rect || !containerRect)
            return;
        const ad1Bottom = ad1Rect.bottom;
        const ad1Top = ad1Rect.top;
        const ad2Top = ad2Rect.top;
        if (scrollDir.current === "down" &&
            ad1Bottom + offset >= ad2Top &&
            !pinnedAd1Ref.current) {
            pinnedAd1Ref.current = true;
            setAd1Top(ad1Top - containerRect.top);
            setpinnedAd1(true);
        }
        if (scrollDir.current === "up" &&
            ad1Top >= stickyTop &&
            pinnedAd1Ref.current) {
            pinnedAd1Ref.current = false;
            setpinnedAd1(false);
        }
    }, [offset, stickyTop, ad1Ref, ad2Ref, containerRef]);
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [handleScroll]);
    return { pinnedAd1, ad1Top };
}
